<template>
  <div class="channel-box">
     <div class="channel-content">
         <!-- <div class="channel-item-add">
             <div class="channel-item-add-image">
                 <i class="el-icon-circle-plus"></i>
             </div>
             <div class="channel-item-add-name">
                 添加API接入
             </div>
         </div> -->
         <div class="channel-item">
             <div class="channel-item-image">
             </div>
             <div class="channel-item-name">
                 企业微信
             </div>
             <div class="channel-item-desc">
                 通过企业微信进行客户运营
             </div>
             <div class="button">
                 <el-button v-if="!isAuthorize" type="danger" size="small" icon="el-icon-warning" @click="dialogVisible = true">未授权，立即授权</el-button>
                 <el-button v-if="isAuthorize" type="danger" size="small" icon="el-icon-success" @click="authorizeDrawer = true">已授权，查看</el-button>
             </div>
             <div class=""></div>
         </div>
     </div>
     <!-- 授权扫码 -->
     <el-dialog
        :visible.sync="dialogVisible"
        :show-close="false"
        :close-on-click-modal="false"
        width="30%">
        <div class="saoma-box">
            <div class="">二维码</div>
            <span style="color:gray">请用企业微信管理员扫码授权</span>
        </div>
    </el-dialog>
    <!-- 查看授权信息 -->
    <el-drawer
        title="查看授权信息"
        :visible.sync="authorizeDrawer"
        size="40%"
        :direction="rtl">
        <div class="authorize-box">
            <div class="authorize-item">
                <div class="label">企业ID</div>
                <div class="content">
                    <el-input v-model="authorize.corpId" placeholder="请输入企业ID"></el-input>
                </div>
            </div>
           <!-- <div class="authorize-item">
                <div class="label">应用ID</div>
                <div class="content">
                    <el-input v-model="authorize.scrmAgentId" placeholder="请输入应用ID"></el-input>
                </div>
            </div>
            <div class="authorize-item">
                <div class="label">应用secret</div>
                <div class="content">
                    <el-input v-model="authorize.scrmAagentSecret" placeholder="请输入应用secret"></el-input>
                </div>
            </div>-->
            <div class="authorize-item">
                <div class="label">通讯录secret</div>
                <div class="content">
                    <el-input v-model="authorize.addressSecret" placeholder="请输入通讯录secret"></el-input>
                </div>
            </div>
            <div class="authorize-item">
                <div class="label">客户secret</div>
                <div class="content">
                    <el-input v-model="authorize.externalSecret" placeholder="请输入客户secret"></el-input>
                </div>
            </div>
            <div class="authorize-item">
                <div class="label">服务器回调地址</div>
                <div class="content">
                    <el-input v-model="authorize.callBackUrl" placeholder="请输入客户secret"></el-input>
                </div>
            </div>
            <div class="authorize-item">
                <div class="label">消息接收token</div>
                <div class="content">
                    <el-input v-model="authorize.token" placeholder="请输入消息接收token"></el-input>
                </div>
            </div>
            <div class="authorize-item">
                <div class="label">Encoding AESKey</div>
                <div class="content">
                    <el-input v-model="authorize.aesKey" placeholder="请输入Encoding AESKey"></el-input>
                </div>
            </div>
            <div class="authorize-item">
                <div class="label">私域AI助手消息推送应用AgentId</div>
                <div class="content">
                    <el-input v-model="authorize.scrmAgentId" placeholder="请输入消息推送应用AgentId"></el-input>
                </div>
            </div>
            <div class="authorize-item">
                <div class="label">私域AI助手消息推送应用Secret</div>
                <div class="content">
                    <el-input v-model="authorize.scrmAagentSecret" placeholder="请输入消息推送应用Secret"></el-input>
                </div>
            </div>
            <div class="authorize-item">
                <div class="label">私域AI助手消息推送应用名称</div>
                <div class="content">
                    <el-input v-model="authorize.scrmAgentName" placeholder="请输入消息推送应用名称"></el-input>
                </div>
            </div>

        </div>
        <div class="authorize-footer">
            <el-button @click="authorizeDrawer = false">取 消</el-button>
            <el-button type="primary" @click="updateAuthorize">保 存</el-button>
        </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
    data(){
        return{
            isAuthorize: true,
            dialogVisible: false,
            authorizeDrawer: false,
            rtl:'rtl',
            authorize:{
                addressSecret:'',
                aesKey:'',
                corpId:'',
                externalSecret:'',
                scrmAagentSecret:'',
                scrmAgentId:'',
                scrmAgentName:'',
                token:'',
                callBackUrl:''
            },
            authorizeId:''
        }
    },
    mounted() {
        this.getWeWorkAuth()
    },
    methods:{
        getWeWorkAuth(){
            this.$http.get('/scrm-api/we-work-auth-info').then(res=>{
                console.log(res)
                if (res.status===200){
                    if (res.data.addressSecret!==null){
                        this.authorize.addressSecret=res.data.addressSecret
                    }
                    if (res.data.aesKey!==null){
                        this.authorize.aesKey=res.data.aesKey
                    }
                    if (res.data.corpId!==null){
                        this.authorize.corpId=res.data.coral
                    }
                    if (res.data.externalSecret!==null){
                        this.authorize.externalSecret=res.data.externalSecret
                    }
                    if (res.data.scrmAagentSecret!==null){
                        this.authorize.scrmAagentSecret=res.data.scrmAagentSecret
                    }
                    if (res.data.scrmAgentId!==null){
                        this.authorize.scrmAgentId=res.data.scrmAgentId
                    }
                    if (res.data.token!==null){
                        this.authorize.token=res.data.token
                    }
                    if (res.data.callBackUrl!==null){
                        this.authorize.callBackUrl=res.data.callBackUrl
                    }
                    this.authorizeId=res.data.id
                    this.authorize.corpId=res.data.corpId
                    this.authorize.scrmAgentName=res.data.scrmAgentName
                }
            })
        },
        updateAuthorize(){
            let url='/scrm-api/we-work-auth-info/'+this.authorizeId
            this.$http.put(url,this.authorize).then(res=>{
                console.log(res)
                if (res.status===200){
                    this.$message({
                        message:'授权信息修改完成',
                        duration:2000,
                        type:'success'
                    })
                }
                this.authorizeDrawer = false
            })
        }
    }
}
</script>

<style lang="less">
@import url('../../assets/less/leadsSetting/channel.less');
</style>